import { Box, CircularProgress, Divider, Button } from "@material-ui/core";
import Profile from "./Profile";
import PopoverMenu from "./PopoverMenu";

const MiddleSection = ({
  menuData,
  classes,
  parseTitle,
  loading,
  activePopover,
  setActivePopover,
  user,
  shoppingCarts,
}) => (
  <Box className={classes.middle}>
    {loading && !menuData && (
      <CircularProgress color="primary" className={classes.circularProgress} />
    )}
    {menuData && (
      <>
        <Box className={classes.secondMenu}>
          {menuData?.menu_segundo &&
            menuData.menu_segundo.map((item, index) =>
              item.submenu && item.submenu.length > 0 ? (
                <PopoverMenu
                  key={index}
                  parseTitle={parseTitle}
                  popoverId={`menu_segundo-${index}`}
                  item={item}
                  classes={classes}
                  className={classes.menuItemSecondary}
                  activePopover={activePopover}
                  setActivePopover={setActivePopover}
                />
              ) : (
                <a
                  key={index}
                  href={item.url}
                  className={classes.menuItemSecondary}
                >
                  {parseTitle(item.title)}
                </a>
              )
            )}
        </Box>
        <Divider orientation="vertical" className={classes.contextDivider} />
        <Box className={classes.socialMenu}>
          {menuData?.menu_social &&
            menuData.menu_social.map((item, index) => (
              <a key={index} href={item.url} className={classes.socialIcon}>
                {parseTitle(item.title)}
              </a>
            ))}
        </Box>
        <Divider orientation="vertical" className={classes.contextDivider} />
        <Box className={classes.authenticateContainer}>
          {user?.data ? (
            <Profile
              user={user}
              classes={classes}
              shoppingCarts={shoppingCarts ?? []}
            />
          ) : (
            <Button
              href="/login"
              variant="contained"
              className={classes.loginButton}
            >
              Login
            </Button>
          )}
        </Box>
      </>
    )}
  </Box>
);

export default MiddleSection;
